import { User } from "firebase/auth";
import huLocale from "date-fns/locale/hu/index";

export type IUser = User;

export const DATE_FN_OPTIONS = { locale: huLocale, weekStartsOn: 1 } as const;
